// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sms-test-container {
  margin-top: 2rem;
}

.toggle-btn {
  margin-bottom: 1rem;
}

.sms-test-panel {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.sms-test-panel h3 {
  margin-top: 0;
  color: #333;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
}

.connection-status {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.status-connected {
  color: #28a745;
  font-weight: bold;
}

.status-error {
  color: #dc3545;
  font-weight: bold;
}

.status-checking {
  color: #ffc107;
  font-weight: bold;
}

.status-message {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.sms-test-form {
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #6c757d;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-top: 1rem;
}

.result-container {
  background-color: #d4edda;
  color: #155724;
  padding: 1rem;
  border-radius: 4px;
  margin-top: 1rem;
}

.result-container h4 {
  margin-top: 0;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.result-container pre {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  overflow-x: auto;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SMSTestPanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".sms-test-container {\n  margin-top: 2rem;\n}\n\n.toggle-btn {\n  margin-bottom: 1rem;\n}\n\n.sms-test-panel {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.sms-test-panel h3 {\n  margin-top: 0;\n  color: #333;\n  font-size: 1.2rem;\n  margin-bottom: 1.5rem;\n}\n\n.connection-status {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.status-connected {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.status-error {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.status-checking {\n  color: #ffc107;\n  font-weight: bold;\n}\n\n.status-message {\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.sms-test-form {\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.875rem;\n  color: #6c757d;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-top: 1rem;\n}\n\n.result-container {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-top: 1rem;\n}\n\n.result-container h4 {\n  margin-top: 0;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.result-container pre {\n  background-color: rgba(255, 255, 255, 0.5);\n  padding: 0.5rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  overflow-x: auto;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
